/* v2-purple-js-1787265309 */
/* ============================================================
   WHOLE FORM BODY BUTTER — Main JavaScript
   ============================================================ */

// ===== COUNTDOWN TIMER (resets at midnight every day) =====
(function() {
  function updateCountdown() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var diff = Math.max(0, midnight - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var hEl = document.getElementById('ann-hours');
    var mEl = document.getElementById('ann-minutes');
    var sEl = document.getElementById('ann-seconds');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();

// ===== GALLERY SWIPE / DOTS / THUMBNAILS =====
var gallerySlides = document.getElementById('gallerySlides');
var galleryDots = document.getElementById('galleryDots');
var galleryThumbs = document.getElementById('galleryThumbs');

function goToSlide(index) {
  if (!gallerySlides) return;
  var slides = gallerySlides.querySelectorAll('.gallery-slide');
  if (!slides[index]) return;

  // On mobile: scroll-based
  gallerySlides.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });

  // On desktop: active-class-based
  slides.forEach(function(s, i) { s.classList.toggle('active', i === index); });

  updateDots(index);
  updateThumbs(index);
}
function updateDots(index) {
  if (!galleryDots) return;
  var dots = galleryDots.querySelectorAll('.gallery-dot');
  dots.forEach(function(d, i) { d.classList.toggle('active', i === index); });
}
function updateThumbs(index) {
  if (!galleryThumbs) return;
  var thumbs = galleryThumbs.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function(t, i) { t.classList.toggle('active', i === index); });
}
if (gallerySlides) {
  gallerySlides.addEventListener('scroll', function() {
    var slides = gallerySlides.querySelectorAll('.gallery-slide');
    var scrollLeft = gallerySlides.scrollLeft;
    var slideWidth = gallerySlides.offsetWidth;
    var index = Math.round(scrollLeft / slideWidth);
    updateDots(index);
    updateThumbs(index);
  });
}

// ===== BENEFIT CARD EXPAND =====
function toggleBenefitCard(card) {
  var isOpen = card.classList.contains('open');
  document.querySelectorAll('.benefit-expand-card.open').forEach(function(c) {
    c.classList.remove('open');
  });
  if (!isOpen) card.classList.add('open');
}

// ===== WEEK TIMELINE =====
function toggleWeek(item) {
  var isActive = item.classList.contains('active');
  document.querySelectorAll('.week-item.active').forEach(function(w) {
    w.classList.remove('active');
  });
  if (!isActive) item.classList.add('active');
}

// ===== VARIANT SELECTOR LOGIC =====
var selectedColor = 'Default Title';
var selectedSize = 'Buy 2 Get 1 Free';
var productVariants = [];

// Parse variant JSON on load
document.addEventListener('DOMContentLoaded', function() {
  var jsonEl = document.getElementById('variantJson');
  if (jsonEl) {
    try { productVariants = JSON.parse(jsonEl.textContent); } catch(e) { console.error('Variant JSON parse error', e); }
  }
  updateSelectedVariant();
});

function selectColor(el, colorName) {
  document.querySelectorAll('.color-swatch').forEach(function(s) { s.classList.remove('active'); });
  el.classList.add('active');
  selectedColor = colorName;
  document.getElementById('selectedColorName').textContent = colorName;
  updateSelectedVariant();

  // Navigate gallery to the color variant's image
  navigateToColorImage(colorName);
}

function navigateToColorImage(colorName) {
  // Use the pre-built color-to-slide-index map from Liquid
  var mapEl = document.getElementById('colorSlideMap');
  if (!mapEl) return;
  try {
    var colorMap = JSON.parse(mapEl.textContent);
    if (colorMap.hasOwnProperty(colorName)) {
      goToSlide(colorMap[colorName]);
    }
  } catch(e) {
    console.error('Color slide map parse error', e);
  }
}

function selectSize(el, sizeName) {
  document.querySelectorAll('.size-pill').forEach(function(s) { s.classList.remove('active'); });
  el.classList.add('active');
  selectedSize = sizeName;
  document.getElementById('selectedSizeName').textContent = sizeName;
  updateSelectedVariant();
}

function updateSelectedVariant() {
  var match = productVariants.find(function(v) {
    return v.option1 === selectedColor || productVariants.length === 1;
  });
  if (match) {
    var btn = document.getElementById('atcBtn');
    if (btn) btn.setAttribute('data-variant-id', match.id);
  }
}

// ===== CART COUNT BADGE =====
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var countEl = document.getElementById('cartCount');
      if (countEl) {
        if (cart.item_count > 0) {
          countEl.textContent = cart.item_count;
          countEl.style.display = '';
        } else {
          countEl.style.display = 'none';
        }
      }
    })
    .catch(function() {});
}
document.addEventListener('DOMContentLoaded', updateCartCount);

// ===== SYNC TOP PRICE ON PAGE LOAD =====
// Bundle init removed — using variant selectors now

// ===== USD PRICE FORMATTER =====
function formatUSD(cents) {
  return '$' + (cents / 100).toFixed(2) + ' USD';
}

// ===== CART DRAWER CONFIG =====
function getCartConfig() {
  var el = document.getElementById('cartDrawerConfig');
  if (!el) return { free_shipping_threshold: 20, free_shipping_enabled: false, upsell_enabled: true, upsell_heading: '67% of customers also bought', upsells: [] };
  try { return JSON.parse(el.textContent); } catch(e) { return { free_shipping_threshold: 20, free_shipping_enabled: false, upsell_enabled: true, upsell_heading: '67% of customers also bought', upsells: [] }; }
}

// ===== CART DRAWER =====
var _cartDrawerCSS = `
  .cd-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9998;opacity:0;transition:opacity .3s ease}
  .cd-drawer{position:fixed;top:0;right:-420px;width:400px;max-width:92vw;height:100%;background:#fff;z-index:9999;box-shadow:-4px 0 20px rgba(0,0,0,0.15);transition:right .3s ease;display:flex;flex-direction:column;font-family:'Outfit','Satoshi',sans-serif}
  .cd-header{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #eee}
  .cd-header h3{margin:0;font-size:18px;font-weight:700;color:#4B1C2A}
  .cd-close{background:none;border:none;font-size:26px;cursor:pointer;color:#4B1C2A;padding:0;line-height:1}
  .cd-shipping-bar{padding:14px 20px;background:#F5B4C5;border-bottom:1px solid #eee}
  .cd-shipping-text{font-size:13px;color:#4B1C2A;text-align:center;margin-bottom:8px;font-weight:500}
  .cd-shipping-text b{color:#4B1C2A;font-weight:700}
  .cd-shipping-track{height:8px;background:#F5B4C5;border-radius:4px;overflow:hidden}
  .cd-shipping-fill{height:100%;background:#4B1C2A;border-radius:4px;transition:width .4s ease}
  .cd-shipping-done .cd-shipping-fill{background:#4B1C2A}
  .cd-body{flex:1;overflow-y:auto;padding:0}
  .cd-items{padding:0 20px}
  .cd-item{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #f0f0f0;position:relative}
  .cd-item-img{width:80px;height:80px;object-fit:cover;border-radius:10px;background:#F5B4C5;flex-shrink:0}
  .cd-item-info{flex:1;display:flex;flex-direction:column;gap:2px}
  .cd-item-title{font-weight:600;font-size:14px;color:#4B1C2A;line-height:1.3}
  .cd-item-variant{font-size:12px;color:#888;margin-top:2px}
  .cd-item-delete{position:absolute;top:16px;right:0;background:none;border:none;cursor:pointer;color:#bbb;padding:4px;transition:color .2s}
  .cd-item-delete:hover{color:#dc2626}
  .cd-item-bottom{display:flex;align-items:center;justify-content:space-between;margin-top:auto;padding-top:6px}
  .cd-qty{display:flex;align-items:center;border:1px solid #ddd;border-radius:6px;overflow:hidden}
  .cd-qty button{width:30px;height:30px;background:#F5B4C5;border:none;cursor:pointer;font-size:16px;font-weight:600;color:#4B1C2A;display:flex;align-items:center;justify-content:center;transition:background .2s}
  .cd-qty button:hover{background:#F5B4C5}
  .cd-qty span{width:32px;text-align:center;font-size:14px;font-weight:600;color:#4B1C2A}
  .cd-item-price{font-size:15px;font-weight:700;color:#4B1C2A}
  .cd-footer{padding:16px 20px;border-top:2px solid #eee}
  .cd-savings{display:flex;justify-content:space-between;margin-bottom:14px;padding:8px 12px;background:#F5B4C5;border-radius:8px}
  .cd-savings span{font-weight:600;font-size:14px;color:#4B1C2A}
  .cd-subtotal{display:flex;justify-content:space-between;margin-bottom:10px}
  .cd-subtotal span:first-child{font-weight:600;font-size:17px;color:#4B1C2A}
  .cd-subtotal span:last-child{font-weight:700;font-size:17px;color:#4B1C2A}
  .cd-subtotal-prices{font-weight:700;font-size:17px;color:#4B1C2A}
  .cd-original-price{color:#999;font-weight:400;font-size:14px;text-decoration:line-through;margin-right:6px}
  .cd-checkout{display:block;width:100%;padding:16px;background:#4B1C2A;color:#fff;text-align:center;border-radius:12px;font-weight:700;font-size:16px;text-decoration:none;border:none;cursor:pointer;text-transform:uppercase;letter-spacing:.5px;transition:background .2s}
  .cd-checkout:hover{background:#4B1C2A}
  .cd-continue{display:block;text-align:center;margin-top:12px;font-size:14px;color:#4B1C2A;text-decoration:underline;cursor:pointer;font-weight:500;background:none;border:none;width:100%}
  .cd-upsell{padding:16px 20px;border-top:1px solid #eee}
  .cd-upsell-heading{background:#4B1C2A;color:#fff;text-align:center;padding:10px 16px;border-radius:10px;font-size:14px;font-weight:600;margin-bottom:12px}
  .cd-upsell-item{display:flex;align-items:center;gap:12px;padding:12px;border:1px solid #eee;border-radius:12px;margin-bottom:8px}
  .cd-upsell-img{width:60px;height:60px;object-fit:cover;border-radius:8px;background:#F5B4C5;flex-shrink:0}
  .cd-upsell-info{flex:1}
  .cd-upsell-title{font-weight:600;font-size:13px;color:#4B1C2A;line-height:1.3}
  .cd-upsell-sub{font-size:11px;color:#888;margin-top:2px}
  .cd-upsell-right{text-align:right;flex-shrink:0}
  .cd-upsell-price{font-weight:700;font-size:14px;color:#4B1C2A;display:block;margin-bottom:6px}
  .cd-upsell-add{background:#F5B4C5;border:1px solid #4B1C2A;color:#4B1C2A;padding:6px 14px;border-radius:8px;font-size:12px;font-weight:600;cursor:pointer;transition:all .2s;white-space:nowrap}
  .cd-upsell-add:hover{background:#4B1C2A;color:#fff}
  .cd-empty{text-align:center;padding:60px 20px;color:#888}
  .cd-empty svg{margin-bottom:16px;opacity:.4}
  .cd-empty p{font-size:15px;margin:0 0 20px}
`;

function injectCartDrawerCSS() {
  if (document.getElementById('cartDrawerCSS')) return;
  var style = document.createElement('style');
  style.id = 'cartDrawerCSS';
  style.textContent = _cartDrawerCSS;
  document.head.appendChild(style);
}

function createCartDrawer() {
  if (document.getElementById('cartDrawerOverlay')) return;
  injectCartDrawerCSS();
  var overlay = document.createElement('div');
  overlay.id = 'cartDrawerOverlay';
  overlay.className = 'cd-overlay';
  overlay.addEventListener('click', closeCartDrawer);
  document.body.appendChild(overlay);

  var drawer = document.createElement('div');
  drawer.id = 'cartDrawer';
  drawer.className = 'cd-drawer';
  drawer.innerHTML = '<div class="cd-header"><h3>Your Cart</h3><button class="cd-close" onclick="closeCartDrawer()">&times;</button></div>'
    + '<div id="cdShippingBar" class="cd-shipping-bar" style="display:none;"></div>'
    + '<div class="cd-body" id="cdBody"><div class="cd-items" id="cdItems"></div><div id="cdUpsell" class="cd-upsell" style="display:none;"></div></div>'
    + '<div class="cd-footer" id="cdFooter"></div>';
  document.body.appendChild(drawer);
}

function renderShippingBar(cart) {
  var cfg = getCartConfig();
  var bar = document.getElementById('cdShippingBar');
  if (!bar || !cfg.free_shipping_enabled) { if (bar) bar.style.display = 'none'; return; }
  var thresholdCents = Math.round((parseFloat(cfg.free_shipping_threshold) || 29.99) * 100);
  var subtotalCents = Number(cart.total_price || 0);
  var remainingCents = Math.max(0, thresholdCents - subtotalCents);
  var progress = thresholdCents > 0 ? Math.min(100, Math.round((subtotalCents / thresholdCents) * 100)) : 100;
  bar.style.display = '';
  bar.className = 'cd-shipping-bar' + (remainingCents === 0 ? ' cd-shipping-done' : '');
  var message = remainingCents === 0
    ? '<b>FREE SHIPPING ON ORDERS $29.99+ — UNLOCKED!</b>'
    : '<b>FREE SHIPPING ON ORDERS $29.99+</b><br>You\'re ' + formatUSD(remainingCents) + ' away';
  bar.innerHTML = '<div class="cd-shipping-text">' + message + '</div><div class="cd-shipping-track"><div class="cd-shipping-fill" style="width:' + progress + '%"></div></div>';
}

function renderUpsells(cart) {
  var cfg = getCartConfig();
  var el = document.getElementById('cdUpsell');
  if (!el || !cfg.upsell_enabled || !cfg.upsells || cfg.upsells.length === 0) { if (el) el.style.display = 'none'; return; }
  var cartIds = cart.items.map(function(i) { return i.variant_id; });
  var available = cfg.upsells.filter(function(u) { return cartIds.indexOf(u.variant_id) === -1; });
  if (available.length === 0) { el.style.display = 'none'; return; }
  el.style.display = '';
  var html = '<div class="cd-upsell-heading">' + cfg.upsell_heading + ' \uD83D\uDC47</div>';
  available.forEach(function(u) {
    html += '<div class="cd-upsell-item">'
      + '<img class="cd-upsell-img" src="' + u.image + '" alt="' + u.title + '">'
      + '<div class="cd-upsell-info"><div class="cd-upsell-title">' + u.title + '</div>' + (u.subtitle ? '<div class="cd-upsell-sub">' + u.subtitle + '</div>' : '') + '</div>'
      + '<div class="cd-upsell-right"><span class="cd-upsell-price">' + formatUSD(u.price) + '</span>'
      + '<button class="cd-upsell-add" onclick="addUpsell(' + u.variant_id + ', this)">Add to Cart</button></div></div>';
  });
  el.innerHTML = html;
}

function addUpsell(variantId, btn) {
  var origText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    updateCartCount();
    refreshCartDrawer();
  })
  .catch(function() {
    btn.textContent = origText;
    btn.disabled = false;
  });
}

function changeCartQty(lineKey, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: newQty })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    updateCartCount();
    refreshCartDrawer();
  });
}

function removeCartItem(lineKey) {
  changeCartQty(lineKey, 0);
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { if (!r.ok) throw new Error('Cart fetch failed'); return r.json(); })
    .then(function(cart) { renderCartDrawerContent(cart); })
    .catch(function() {
      setTimeout(function() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { renderCartDrawerContent(cart); }).catch(function() {});
      }, 1000);
    });
}

function renderCartDrawerContent(cart) {
  var itemsEl = document.getElementById('cdItems');
  var footerEl = document.getElementById('cdFooter');
  if (!itemsEl || !footerEl) return;

  renderShippingBar(cart);

  if (cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="cd-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><p>Your cart is empty</p><button class="cd-checkout" onclick="closeCartDrawer()">Continue Shopping</button></div>';
    footerEl.innerHTML = '';
    document.getElementById('cdUpsell').style.display = 'none';
    return;
  }

  var html = '';
  // Group items: combine paid items and free items by product
  var grouped = {};
  cart.items.forEach(function(item) {
    var pid = item.product_id;
    var isFree = (item.final_line_price === 0 || item.final_price === 0);
    var gkey = pid + '_' + (isFree ? 'free' : 'paid');
    if (!grouped[gkey]) {
      grouped[gkey] = { item: item, qty: 0, totalPrice: 0, isFree: isFree, keys: [] };
    }
    grouped[gkey].qty += item.quantity;
    grouped[gkey].totalPrice += item.final_line_price;
    grouped[gkey].keys.push({ key: item.key, qty: item.quantity });
  });
  // Render paid items first, then free items
  var sortedKeys = Object.keys(grouped).sort(function(a,b) {
    return (grouped[a].isFree ? 1 : 0) - (grouped[b].isFree ? 1 : 0);
  });
  sortedKeys.forEach(function(gkey) {
    var g = grouped[gkey];
    var item = g.item;
    var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var priceDisplay = g.isFree ? '<span style="color:#4B1C2A;font-weight:600">FREE</span>' : formatUSD(g.totalPrice);
    var firstKey = g.keys[0].key;
    html += '<div class="cd-item">'
      + '<img class="cd-item-img" src="' + (item.image || document.querySelector('.bb-gallery-slide img')?.src || '') + '" alt="' + item.product_title + '">'
      + '<div class="cd-item-info">'
      + '<div class="cd-item-title">' + item.product_title + '</div>'
      + (variantTitle ? '<div class="cd-item-variant">' + variantTitle + '</div>' : '')
      + '<div class="cd-item-bottom">'
      + '<div class="cd-qty"><span style="padding:4px 12px">' + g.qty + '</span></div>'
      + '<div class="cd-item-price">' + priceDisplay + '</div>'
      + '</div></div>'
      + '<button class="cd-item-delete" onclick="removeCartItem(\'' + firstKey + '\')" title="Remove">'
      + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>'
      + '</button></div>';
  });
  itemsEl.innerHTML = html;

  // Calculate discount: sum of all items at full price vs what they're paying
  var totalItems = 0;
  var freeItems = 0;
  var totalPaid = cart.total_price;
  cart.items.forEach(function(item) {
    totalItems += item.quantity;
    if (item.final_line_price === 0) freeItems += item.quantity;
  });
  // Use actual Shopify pre-discount totals for each product, not a hard-coded supplement price.
  var fullPrice = Number(cart.original_total_price || cart.total_price || 0);
  var savings = fullPrice - totalPaid;
  var savingsHTML = '';
  if (savings > 0 && freeItems > 0) {
    var freeText = freeItems + ' free item' + (freeItems > 1 ? 's' : '') + ' included';
    savingsHTML = '<div class="cd-savings"><span>You save ' + formatUSD(savings) + '</span><span>\u2714 ' + freeText + '</span></div>';
  }

  var subtotalRight = savings > 0
    ? '<span class="cd-subtotal-prices"><s class="cd-original-price">' + formatUSD(fullPrice) + '</s> ' + formatUSD(cart.total_price) + '</span>'
    : '<span>' + formatUSD(cart.total_price) + '</span>';
  footerEl.innerHTML = '<div class="cd-subtotal"><span>Subtotal</span>' + subtotalRight + '</div>'
    + savingsHTML
    + '<a href="/checkout" class="cd-checkout">Checkout</a>'
    + '<button class="cd-continue" onclick="closeCartDrawer()">Continue Shopping</button>';

  renderUpsells(cart);
}

function openCartDrawer() {
  createCartDrawer();
  // Show drawer immediately
  var overlay = document.getElementById('cartDrawerOverlay');
  var drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.style.opacity = '1';
  if (drawer) drawer.style.right = '0';
  document.body.style.overflow = 'hidden';
  // Then fetch cart data
  fetch('/cart.js')
    .then(function(r) { if (!r.ok) throw new Error('Cart fetch failed'); return r.json(); })
    .then(function(cart) {
      renderCartDrawerContent(cart);
    })
    .catch(function() {
      var itemsEl = document.getElementById('cdItems');
      if (itemsEl) itemsEl.innerHTML = '<p style="text-align:center;color:#888;padding:40px 20px;">Loading cart...</p>';
      // Retry once after a short delay
      setTimeout(function() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          renderCartDrawerContent(cart);
        }).catch(function() {});
      }, 1500);
    });
}

function closeCartDrawer() {
  var overlay = document.getElementById('cartDrawerOverlay');
  var drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.style.opacity = '0';
  if (drawer) drawer.style.right = '-420px';
  document.body.style.overflow = '';
  setTimeout(function() {
    if (overlay) overlay.remove();
    if (drawer) drawer.remove();
  }, 300);
}

// Make header cart icon open drawer instead of navigating
document.addEventListener('DOMContentLoaded', function() {
  var cartLink = document.querySelector('.header-cart');
  if (cartLink) {
    cartLink.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }
});

// ===== ADD TO CART =====
var BUNDLE_QTY_MAP = {
  'Buy 1': 1,
  'Buy 2 Get 1 Free': 3,
  'Buy 3 Get 2 Free': 5
};

function handleAddToCart() {
  var btn = document.getElementById('atcBtn');
  if (!btn) return;
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) {
    alert('Product not found. Please refresh the page.');
    return;
  }
  // Determine quantity from active bundle card
  var qty = 3; // default to Buy 2 Get 1 Free
  var activeCard = document.querySelector('.bundle-card.active');
  if (activeCard) {
    var bundleName = activeCard.getAttribute('data-size');
    if (BUNDLE_QTY_MAP[bundleName]) {
      qty = BUNDLE_QTY_MAP[bundleName];
    }
  }
  var origHTML = btn.innerHTML;
  btn.innerHTML = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    btn.innerHTML = '&#10003; Added to Cart!';
    btn.style.background = '#4B1C2A';
    updateCartCount();
    setTimeout(function() { openCartDrawer(); }, 400);
    setTimeout(function() {
      btn.innerHTML = origHTML;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  })
  .catch(function(err) {
    btn.innerHTML = 'Error \u2014 Try Again';
    btn.style.background = '#dc2626';
    setTimeout(function() {
      btn.innerHTML = origHTML;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  });
}

// ===== STAT COUNTER ANIMATION =====
function animateStats() {
  var stats = document.querySelectorAll('.stat-number[data-target]');
  var duration = 1800;
  var sharedStart = null;
  function tick(timestamp) {
    if (!sharedStart) sharedStart = timestamp;
    var progress = Math.min((timestamp - sharedStart) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    stats.forEach(function(el) {
      var target = parseInt(el.getAttribute('data-target'));
      var suffix = el.getAttribute('data-suffix') || '';
      el.textContent = (progress === 1 ? target : Math.floor(eased * target)) + suffix;
    });
    if (progress < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

// Trigger stat animation when section enters viewport
var statsSection = document.querySelector('.stats-section');
if (statsSection && 'IntersectionObserver' in window) {
  var statsObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateStats();
        statsObserver.disconnect();
      }
    });
  }, { threshold: 0.05 });
  statsObserver.observe(statsSection);
}

// ===== REASONS DOTS =====
var reasonsGrid = document.getElementById('reasonsGrid');
var reasonsDots = document.getElementById('reasonsDots');

if (reasonsGrid && reasonsDots) {
  reasonsGrid.addEventListener('scroll', function() {
    var cards = reasonsGrid.querySelectorAll('.reason-card');
    var scrollLeft = reasonsGrid.scrollLeft;
    var cardWidth = cards[0] ? cards[0].offsetWidth + 12 : 272;
    var index = Math.round(scrollLeft / cardWidth);
    var dots = reasonsDots.querySelectorAll('.reasons-dot');
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === index);
    });
  });
  reasonsDots.querySelectorAll('.reasons-dot').forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      var cards = reasonsGrid.querySelectorAll('.reason-card');
      var cardWidth = cards[0] ? cards[0].offsetWidth + 12 : 272;
      reasonsGrid.scrollTo({ left: i * cardWidth, behavior: 'smooth' });
    });
  });
}

// ===== STICKY HEADER SHADOW =====
window.addEventListener('scroll', function() {
  var header = document.querySelector('.site-header');
  if (header) {
    header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(75, 28, 42,0.12)' : '';
  }
});

// ===== FAQ TOGGLE =====
function toggleFaq(item) {
  var wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(f) {
    f.classList.remove('open');
  });
  if (!wasOpen) { item.classList.add('open'); }
}
